(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* Countdown cells in the product card and final call-to-action */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function timerEnd(t) {
    if (t.getAttribute('data-mode') === 'visitor') {
      var mins = Math.max(1, parseFloat(t.getAttribute('data-minutes')) || 30);
      var resetH = parseFloat(t.getAttribute('data-reset'));
      var resetMs = (isNaN(resetH) ? 24 : resetH) * 3600000;
      var storeKey = 'parcelTimer:' + (t.getAttribute('data-key') || 'main');
      var now = Date.now(), startAt = NaN;
      try { startAt = parseInt(localStorage.getItem(storeKey), 10); } catch (e) {}
      var over = !isNaN(startAt) && now > startAt + mins * 60000;
      if (isNaN(startAt) || startAt > now || (over && resetMs > 0 && now > startAt + mins * 60000 + resetMs)) {
        startAt = now;
        try { localStorage.setItem(storeKey, String(startAt)); } catch (e) {}
      }
      return startAt + mins * 60000;
    }
    return Date.parse(t.getAttribute('data-end'));
  }
  function initTimers() {
    $$('[data-countdown]').forEach(function (t) {
      if (!once(t, 'cd')) return;
      var end = timerEnd(t);
      if (isNaN(end) || end <= Date.now()) return;
      var h = $('[data-cd="h"]', t), m = $('[data-cd="m"]', t), sc = $('[data-cd="s"]', t);
      t.hidden = false;
      (function tick() {
        var s = Math.floor((end - Date.now()) / 1000);
        if (s <= 0) { t.hidden = true; return; }
        h.textContent = pad(Math.floor(s / 3600));
        m.textContent = pad(Math.floor((s % 3600) / 60));
        sc.textContent = pad(s % 60);
        setTimeout(tick, 1000);
      })();
    });
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function once(el, key) { if (el['_' + key]) return false; el['_' + key] = true; return true; }
  var d = document;
  /* ---------- Countdown (counts down to a real end date; used in the top bar and product card) ---------- */
  function initBarCountdown(el) {
    var end;
    if (el.getAttribute('data-mode') === 'visitor') {
      // Each visitor gets their own timer, started on their first visit and remembered in this browser.
      var mins = Math.max(1, parseFloat(el.getAttribute('data-minutes')) || 30);
      var resetH = parseFloat(el.getAttribute('data-reset'));
      var resetMs = (isNaN(resetH) ? 24 : resetH) * 3600000;
      var storeKey = 'parcelTimer:' + (el.getAttribute('data-key') || 'main');
      var now = Date.now(), startAt = NaN;
      try { startAt = parseInt(localStorage.getItem(storeKey), 10); } catch (e) {}
      var over = !isNaN(startAt) && now > startAt + mins * 60000;
      if (isNaN(startAt) || startAt > now || (over && resetMs > 0 && now > startAt + mins * 60000 + resetMs)) {
        startAt = now;
        try { localStorage.setItem(storeKey, String(startAt)); } catch (e) {}
      }
      end = startAt + mins * 60000;
    } else {
      end = Date.parse(el.getAttribute('data-end'));
    }
    var out = $('[data-countdown-time]', el);
    if (isNaN(end) || end <= Date.now() || !out) return;
    var segments = el.classList.contains('timerbar');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { el.hidden = true; return; }
      var days = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600),
          m = Math.floor(left % 3600 / 60), s = left % 60;
      var parts = [pad(h), pad(m), pad(s)];
      if (days > 0) parts.unshift(days + 'd');
      if (segments) out.innerHTML = '<b>' + parts.join('</b><em>:</em><b>') + '</b>';
      else out.textContent = parts.join(' : ');
      setTimeout(tick, 1000);
    }
    el.hidden = false;
    tick();
  }

  /* ---------- Fixed top bars: keep other things clear of them ---------- */
  function initTopbar() {
    var bar = $('[data-topbar]');
    var proof = null;
    if (!bar && !proof) return;
    var key = bar || proof;
    if (!once(key, 'init')) return;
    function fixedHeight(el) {
      if (!el || el.getAttribute('data-sticky') !== 'true') return 0;
      var wrap = el.closest('.shopify-section') || el;
      return Math.ceil(wrap.getBoundingClientRect().height);
    }
    function measure() {
      var p = fixedHeight(proof), t = fixedHeight(bar), h = p + t;
      d.documentElement.style.setProperty('--lovedby-h', p + 'px');
      d.documentElement.style.setProperty('--topbar-h', h + 'px');
      d.documentElement.style.scrollPaddingTop = (h ? h + 12 : 0) + 'px';
    }
    measure();
    window.addEventListener('resize', measure);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(measure);
    setTimeout(measure, 1500);
  }

  /* ---------- "Loved by" bar: count the number up on every page load ---------- */
  function initLovedBy() {
    var root = $('[data-lovedby]');
    if (!root || !once(root, 'count')) return;
    var el = $('[data-lovedby-count]', root);
    if (!el) return;
    var raw = (el.textContent || '').trim();
    var m = raw.match(/^([^\d]*)(\d[\d.,\s]*)(.*)$/);
    if (!m) return;
    var lead = m[1], numStr = m[2].replace(/\s+$/, ''), tail = m[3] + (m[2].length > numStr.length ? m[2].slice(numStr.length) : '');
    var decimals = 0;
    var lastDot = numStr.lastIndexOf('.'), lastComma = numStr.lastIndexOf(',');
    var sepIdx = Math.max(lastDot, lastComma);
    if (sepIdx > -1 && numStr.length - sepIdx - 1 !== 3) decimals = numStr.length - sepIdx - 1;
    var target = decimals
      ? parseFloat(numStr.slice(0, sepIdx).replace(/[.,]/g, '') + '.' + numStr.slice(sepIdx + 1))
      : parseInt(numStr.replace(/[.,]/g, ''), 10);
    if (!isFinite(target) || target <= 0 || reduce) return;
    var duration = Math.max(0.5, parseFloat(root.getAttribute('data-duration')) || 2.5) * 1000;
    var fmt;
    try { fmt = new Intl.NumberFormat(d.documentElement.lang || undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }); }
    catch (e) { return; }
    var text = el.parentNode;
    // hold the final width so the bar does not jiggle while digits change
    el.style.setProperty('--count-w', Math.ceil(el.getBoundingClientRect().width) + 'px');
    var render = function (v) { el.textContent = lead + fmt.format(v) + tail; };
    render(0);
    text.classList.add('is-counting');
    var start = null;
    function easeOut(t) { return 1 - Math.pow(1 - t, 4); }
    function frame(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      render(decimals ? Math.round(target * easeOut(t) * Math.pow(10, decimals)) / Math.pow(10, decimals) : Math.round(target * easeOut(t)));
      if (t < 1) requestAnimationFrame(frame);
      else { el.textContent = raw; text.classList.remove('is-counting'); }
    }
    setTimeout(function () { requestAnimationFrame(frame); }, 250);
  }

  /* Sticky buy bar: always on screen. Shakes after a delay and rotates purchase notices above itself. */
  function initSticky() {
    var bar = $('[data-sticky-bar]');
    if (!bar || !once(bar, 'sticky')) return;
    document.body.classList.add('has-sticky');
    function measure() {
      d.documentElement.style.setProperty('--sticky-h', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(measure);

    var shakeOn = bar.getAttribute('data-shake') === 'true';
    var shakeDelay = Math.max(1, parseFloat(bar.getAttribute('data-shake-delay')) || 4) * 1000;
    if (shakeOn && !reduce) setTimeout(function () { bar.classList.add('is-shaking'); }, shakeDelay);

    var notice = $('[data-notice]', bar);
    if (!notice) return;
    var msgs = $$('[data-notice-list] li', notice).map(function (li) { return li.textContent; });
    var out = $('[data-notice-text]', notice);
    if (!msgs.length || !out) return;
    var every = Math.max(1, parseFloat(notice.getAttribute('data-interval')) || 1) * 1000;
    var i = Math.floor(Math.random() * msgs.length);
    function show() {
      out.textContent = msgs[i % msgs.length];
      i++;
      notice.classList.remove('is-swap');
      void notice.offsetWidth;
      notice.classList.add('is-swap');
      measure();
    }
    show();
    if (msgs.length > 1) setInterval(show, every);
  }

  /* Gallery */
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      if (!once(g, 'g')) return;
      var main = $('[data-gallery-main]', g);
      $$('[data-thumb]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          main.src = b.getAttribute('data-src');
          main.srcset = b.getAttribute('data-srcset') || '';
          main.alt = b.getAttribute('data-alt') || '';
          $$('[data-thumb]', g).forEach(function (o) { o.removeAttribute('aria-current'); });
          b.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* Carousel + lightbox */
  function initCarousels() {
    var box = $('[data-lightbox]');
    $$('[data-carousel]').forEach(function (c) {
      if (!once(c, 'c')) return;
      var track = $('[data-track]', c);
      var step = function () { return Math.max(track.clientWidth * 0.8, 240); };
      var p = $('[data-prev]', c), n = $('[data-next]', c);
      if (p) p.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      $$('[data-zoom]', c).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!box || !box.showModal) return;
          var img = $('img', box);
          img.src = b.getAttribute('data-zoom');
          img.alt = b.getAttribute('data-alt') || '';
          box.showModal();
        });
      });
    });
    if (box) {
      box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('[data-close]')) box.close(); });
    }
  }

  /* Reveal + progress bars */
  function initReveal() {
    var els = $$('.reveal, [data-bars]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Mobile nav */
  function initNav() {
    var t = $('[data-nav-toggle]'), n = $('[data-nav]');
    if (!t || !n || !once(t, 'nav')) return;
    t.addEventListener('click', function () {
      var open = n.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open);
    });
  }

  /* Prevent double submits on buy buttons */
  function initCta() {
    $$('[data-cta-form]').forEach(function (f) {
      if (!once(f, 'f')) return;
      f.addEventListener('submit', function () {
        var b = $('button', f);
        if (b) { b.disabled = true; b.style.opacity = '.7'; }
        setTimeout(function () { if (b) { b.disabled = false; b.style.opacity = ''; } }, 6000);
      });
    });
  }

  function init() { initTimers(); $$('[data-bar-countdown]').forEach(function (el) { if (once(el, 'init')) initBarCountdown(el); }); initTopbar(); initLovedBy(); initGallery(); initCarousels(); initReveal(); initSticky(); initNav(); initCta(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
